import { IContainer, ILazyBinder, injectContainer } from './container';

export type LANGUAGE_CODE =
    | 'cs'
    | 'de'
    | 'en'
    | 'es'
    | 'fr'
    | 'it'
    | 'ja'
    | 'ko'
    | 'pl'
    | 'pt'
    | 'ru'
    | 'zh'
    | 'nl'
    | 'ar'
    | 'bp'
    | 'ga'
    | 'gd';

export interface ITranslationStorage {
    translation: (
        language: LANGUAGE_CODE,
        key: string,
        parameters?: Array<string>,
        fallback?: string,
    ) => string;
}

const TYPES = {
    ITranslationStorage: Symbol.for('ITranslationStorage'),
};

export function injectTranslationStorage(
    container: IContainer = injectContainer(),
): Promise<ITranslationStorage> {
    return container.get<ILazyBinder<ITranslationStorage>>(TYPES.ITranslationStorage)();
}

export function bindTranslationStorage(
    val: ILazyBinder<ITranslationStorage>,
    container: IContainer = injectContainer(),
) {
    return container.bind<ILazyBinder<ITranslationStorage>>(TYPES.ITranslationStorage, val);
}
